import React from 'react';
import { Card } from '../../../components/Containers';
import { RuleEditorTitle } from './RuleEditorTitle';
import { OffsetReferencePointNames } from './RuleTargetConstants';

export class RuleTargetCard extends React.Component {

    constructor(props) {
        super(props);

        if (!this.props.ruleTarget) {
            throw new Error("ruleTarget Property is required");
        }

        this.target = this.props.ruleTarget;
        this.datasourceDefinitions = this.props.datasourceDefinitions;
        this.onDeleteClick = this.onDeleteClick.bind(this);
    }

    onDeleteClick() {
        if (this.props.onDeleteClick) {
            this.props.onDeleteClick(this.target);
        }
    }

    getAffinityText() {
        var result = null;
        switch (this.target.affinity) {
            case 1:
                result = 'Exclusive';
                break;
            case 2:
                result = 'Include';
                break;
            case 3:
                result = 'Exclude';
                break;
            case 4:
                result = 'Forbidden Range';
                break;
            default:
                throw new Error(`Affinity ${this.target.affinity} is not supported`);
        }
        return result;
    }

    getLocationText() {
        var result = 'Independend';
        switch (this.target.location) {
            case 2:
                result = `Centered To ${this.getRelatedFeature()}`;
                break;
            case 3:
                result = `Fix Location from Pouch Top`;
                break;
            default:
                break;
        }
        return result;
    }

    getRelatedFeature() {        
        var feature = this.datasourceDefinitions.items.find(e => e.id == this.target.relatedFeature);
        return feature.name;
    }

    render() {
        var self = this;
        var isForbiddenRange = this.target.affinity === 4;
        var subtitle = isForbiddenRange
            ? `The ${this.target.definition.name} offset will be constrained:`
            : `The ${this.target.definition.name} options will be limited to:`;

        return (
            <Card title={<RuleEditorTitle title={this.target.definition.name} button={<span className='glyphicon glyphicon-remove'></span>} disabled={this.props.preventEdit} onClick={() => this.onDeleteClick()} />} noIcon={true} subtitle={subtitle}>

                <div className="card-body">
                    {isForbiddenRange ? (
                        <div className="rule-summary-grid">
                            <div className="rule-summary-item">
                                <label>Affinity</label>
                                <p className="card-text">{this.getAffinityText()}</p>
                            </div>
                            <div className="rule-summary-item">
                                <label>Reference Point</label>
                                <p className="card-text">{OffsetReferencePointNames[this.target.location] || this.target.location}</p>
                            </div>
                            <div className="rule-summary-item">
                                <label>Min offset</label>
                                <p className="card-text">{this.target.offset != null ? `${this.target.offset} mm/in` : '—'}</p>
                            </div>
                            <div className="rule-summary-item">
                                <label>Max offset</label>
                                <p className="card-text">{this.target.offsetTo != null ? `${this.target.offsetTo} mm/in` : '—'}</p>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="rule-summary-grid">
                                <div className="rule-summary-item">
                                    <label>Items</label>
                                    <div className="rule-summary-list">
                                        {this.target.items.map(function (item, idx) {
                                            return (
                                                <p key={`tar_${idx}`} className="card-text">{item.name}</p>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div className="rule-summary-item">
                                    <label>Affinity</label>
                                    <p className="card-text">{this.getAffinityText()}</p>
                                </div>
                            </div>

                            {this.target.location > 1 &&
                                <div className="rule-summary-grid rule-summary-grid-secondary">
                                    <div className="rule-summary-item">
                                        <label>Location</label>
                                        <p className="card-text">{this.getLocationText()}</p>
                                    </div>

                                    <div className="rule-summary-item">
                                        <label>Offset</label>
                                        <p className="card-text">{this.target.offset.toFixed(4)} mm/in</p>
                                    </div>
                                </div>
                            }
                        </div>
                    )}
                </div>

            </Card>

        );
    }
}